import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { SnackComponent } from './snack.component';
import { SnackbarService } from './snackbar.service';
import { UtilsModule } from '../utils/utils.module';
import { SnackbarComponent } from './snackbar.component';

@NgModule({
  declarations: [SnackbarComponent, SnackComponent],
  imports: [CommonModule, UtilsModule],
  exports: [SnackbarComponent]
})
export class SnackbarModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: SnackbarModule,
      providers: [SnackbarService]
    };
  }
}
